// Opciones frecuentes de las condiciones comerciales. El Pricer es sólo de Datec, así que viven acá como
// constantes: para cambiar una, se edita este archivo. La opción «Otro…» no es un valor: abre un campo de texto
// libre.

export const OTRO = 'Otro…';

export const FORMAS_DE_PAGO: readonly string[] = [
  'Contado',
  'Crédito a 15 días',
  'Crédito a 30 días',
  'Crédito a 45 días',
  'Crédito a 60 días',
  '50 % anticipo y 50 % contra entrega',
  'Según contrato',
];

export const PLAZOS_DE_ENTREGA: readonly string[] = [
  'A confirmar según disponibilidad',
  'Inmediata (en stock)',
  '15 días',
  '30 días',
  '45 días',
  '60 días',
  '90 días',
];

/** Largo sugerido de las notas y los términos: no bloquea, avisa. */
export const LIMITE_SUAVE_NOTAS = 1500;
